<!--时间选择器-->
<template>
  <div>
    <van-field
      :required="required && !disabled"
      :show-error="false"
      :name="name"
      :value="modelValue"
      placeholder="请选择"
      :label="label"
      input-align="right"
      readonly
      :right-icon="disabled ? '' : 'arrow'"
      @click="!disabled && (visible = true)"
      :rules="[{ validator }]"
    />
    <van-popup v-model="visible" position="bottom">
      <van-datetime-picker
        type="date"
        @cancel="visible = false"
        @confirm="onConfirmDate"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>
  </div>
</template>

<script>
  import { formatDate } from '@/utils';
  export default {
    data() {
      return {
        minDate: new Date(),
        maxDate: new Date(2099, 11, 31),
        currentDate: new Date(),
        visible: false,
        errMsg: '',
      };
    },
    props: {
      name: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        default: '',
      },
      modelValue: {
        type: String,
        default: '',
      },
      required: {
        type: Boolean,
        default: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    methods: {
      // 校验方法
      validator(val, rule) {
        if (!this.required || this.disabled) return val;
        if (!val) {
          rule.message = '请选择道路运输证有效期';
          return false;
        }
        if (val < this.currentDate) {
          rule.message = '请选择正确的道路运输证有效期';
          return false;
        }
      },
      // 确认时间
      onConfirmDate(val) {
        this.$emit('update:modelValue', formatDate(val));
        this.$emit('confirm', formatDate(val));
        this.visible = false;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .by-red {
    color: red;
    padding: 0 3px;
    font-size: 14px;
  }
</style>
